module.exports = __webpack_public_path__ + "img/run-cancelled.0b67524.png";